module.exports = __webpack_public_path__ + "static/media/contenido-orientacion.fdb8d8d4.svg";